import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useMutation } from "react-query";

// Backend Api
export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl:
      process.env.REACT_APP_BASE_URL ||
      "http://localhost:5001",
  }), // base url
  reducerPath: "adminApi",
  // tags
  tagTypes: [
    "User",
    "Producs",
    "Customers",
    "ReportedCustomers",
    "ReportedCustomerDetail",
    "DisableUser",
    "Yogas",
    "CreateYoga",
    "Transactions",
    "Geography",
    "Sales",
    "Admins",
    "Performance",
    "Dashboard",
    "Religions",
    "CreateReligions",
    "UpdateReligion",
    "DeleteReligion",
    "Languages",
    "CreateLanguage",
    "UpdateLanguage",
    "DeleteLanguage",
    "ContactUsCategories",
    "CreateContactUsCategory",
    "UpdateContactUsCategory",
    "DeleteContactUsCategory",
    "CreateRequestCategories",
    "CreateCreateRequestCategory",
    "UpdateCreateRequestCategory",
    "DeleteCreateRequestCategory",
    "ServiceProviderRequestCategories",
    "CreateServiceProviderRequestCategory",
    "UpdateServiceProviderRequestCategory",
    "DeleteServiceProviderRequestCategory",
    "UserInterestRequestCategories",
    "CreateUserInterestRequestCategory",
    "UpdateUserInterestRequestCategory",
    "DeleteUserInterestRequestCategory",
    "UserActivityRequestCategories",
    "CreateUserActivityRequestCategory",
    "UpdateUserActivityRequestCategory",
    "DeleteUserActivityRequestCategory",
    "GoalCategories",
    "CreateGoalCategory",
    "UpdateGoalCategory",
    "DeleteGoalCategory",
    "WebsiteInterest",
    "YogaEmpowerCategories", 
    "UpdateYogaEmpowerCategories",
    "CreateYogaEmpowerCategories",
    "DeleteYogaEmpowerCategories",
    "UpdateCoupons",
    "CreateCoupons",
    "DeleteCoupons",
    "Coupons"
  

  ],
  // endpoints
  endpoints: (build) => ({
    getUser: build.query({
      query: (id) => `general/user/${id}`,
      providesTags: ["User"],
    }),
    getProducts: build.query({
      query: () => "client/products",
      providesTags: ["Products"],
    }),
    getCustomers: build.query({
      query: () => "client/customers",
      providesTags: ["Customers"],
    }),
    getReportedCustomers: build.query({
      query: () => "client/reportedCustomers",
      providesTags: ["ReportedCustomers"],
    }),
    getWebsiteInterest: build.query({
      query: () => "client/getWebsiteIntresets",
      providesTags: ["WebsiteInterest"],
    }),
    getReportedCustomerDetail: build.query({
      query: (id) => `client/reportedCustomerDetail/?id=${id}`,

      providesTags: ["ReportedCustomerDetail"],
    }),
    updateDisableUser: build.mutation({
      query: (id) => ({
        url: `client/disableUser/?id=${id}`, 
        method: 'POST'
      }),


      providesTags: ["DisableUser"],
    }),
    getYogas: build.query({
      query: () => "client/yogas",
      providesTags: ["Yogas"],
    }),


    createYoga: build.mutation({
      query: (data) => ({
        url: "client/createYoga",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CYogas"], // Assuming "Yogas" is the tag for the data you want to refetch after creating a new yoga entry
    }),
    updateYoga: build.mutation({
      query: (data) => ({
        url: "client/updateYoga",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UYogas"],
    }),
    deleteYoga: build.mutation({
      query: (data) => ({
        url: "client/deleteYoga",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DYogas"],
    }),

    getReligions: build.query({
      query: () => "client/religions",
      providesTags: ["Religions"],
    }),

    createReligions: build.mutation({
      query: (data) => ({
        url: "client/createReligion",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CReligions"],
    }),

    updateReligion: build.mutation({
      query: (data) => ({
        url: "client/updateReligion",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UReligions"],
    }),

    deleteReligion: build.mutation({
      query: (data) => ({
        url: "client/deleteReligion",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DReligions"],
    }),

    // deleteYoga: build.query({
    //   query: (id) => `client/updateYoga/${id}`,
    //   providesTags: ["DYogas"],
    // }),
    getTransactions: build.query({
      query: ({ page, pageSize, sort, search }) => ({
        url: "client/transactions",
        method: "GET",
        params: { page, pageSize, sort, search },
      }),
      providesTags: ["Transactions"],
    }),
    getGeography: build.query({
      query: () => "client/geography",
      providesTags: ["Geography"],
    }),
    getSales: build.query({
      query: () => "sales/sales",
      providesTags: ["Sales"],
    }),
    getAdmins: build.query({
      query: () => "management/admins",
      providesTags: ["Admins"],
    }),
    getUserPerformance: build.query({
      query: (id) => `management/performance/${id}`,
      providesTags: ["Performance"],
    }),
    getDashboard: build.query({
      query: () => "general/dashboard",
      providesTags: ["Dashboard"],
    }),
    getLanguage: build.query({
      query: () => "client/languages",
      providesTags: ["Languages"],
    }),
    createLanguage: build.mutation({
      query: (data) => ({
        url: "client/createLanguage",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CLanguages"],
    }),
    updateLanguage: build.mutation({
      query: (data) => ({
        url: "client/updateLanguage",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ULanguages"],
    }),
    deleteLanguage: build.mutation({
      query: (data) => ({
        url: "client/deleteLanguage",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DLanguages"],
    }),
    ///contact Us Categories

    getContactUsCategories: build.query({
      query: () => "client/contactUsCategories",
      providesTags: ["ContactUsCategories"],
    }),
    createContactUsCategories: build.mutation({
      query: (data) => ({
        url: "client/createContactUsCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CContactUsCategories"],
    }),
    updateContactUsCategories: build.mutation({
      query: (data) => ({
        url: "client/updateContactUsCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UContactUsCategories"],
    }),
    deleteContactUsCategories: build.mutation({
      query: (data) => ({
        url: "client/deleteContactUsCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DContactUsCategories"],
    }),


    /// CreateRequestCategories

    getCreateRequestCategories: build.query({
      query: () => "client/createRequestCategories",
      providesTags: ["CreateRequestCategories"],
    }),
    createCreateRequestCategories: build.mutation({
      query: (data) => ({
        url: "client/createCreateRequestCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CCreateRequestCategories"],
    }),
    updateCreateRequestCategories: build.mutation({
      query: (data) => ({
        url: "client/updateCreateRequestCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UCreateRequestCategories"],
    }),
    deleteCreateRequestCategories: build.mutation({
      query: (data) => ({
        url: "client/deleteCreateRequestCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DCreateRequestCategories"],
    }),
    /// ServiceProviderCategories

    getServiceProviderCategories: build.query({
      query: () => "client/serviceProviderCategories",
      providesTags: ["ServiceProviderCategories"],
    }),
    createServiceProviderCategories: build.mutation({
      query: (data) => ({
        url: "client/createServiceProviderCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CServiceProviderCategories"],
    }),
    updateServiceProviderCategories: build.mutation({
      query: (data) => ({
        url: "client/updateServiceProviderCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UServiceProviderCategories"],
    }),
    deleteServiceProviderCategories: build.mutation({
      query: (data) => ({
        url: "client/deleteServiceProviderCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DServiceProviderCategories"],
    }),
    /// UserInterestCategories

    getUserInterestCategories: build.query({
      query: () => "client/userInterestCategories",
      providesTags: ["UserInterestCategories"],
    }),
    createUserInterestCategories: build.mutation({
      query: (data) => ({
        url: "client/createUserInterestCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CUserInterestCategories"],
    }),
    updateUserInterestCategories: build.mutation({
      query: (data) => ({
        url: "client/updateUserInterestCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UUserInterestCategories"],
    }),
    deleteUserInterestCategories: build.mutation({
      query: (data) => ({
        url: "client/deleteUserInterestCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DUserInterestCategories"],
    }),
    /// UserActivityCategories

    getUserActivityCategories: build.query({
      query: () => "client/userActivityCategories",
      providesTags: ["UserActivityCategories"],
    }),
    createUserActivityCategories: build.mutation({
      query: (data) => ({
        url: "client/createUserActivityCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CUserActivityCategories"],
    }),
    updateUserActivityCategories: build.mutation({
      query: (data) => ({
        url: "client/updateUserActivityCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UUserActivityCategories"],
    }),
    deleteUserActivityCategories: build.mutation({
      query: (data) => ({
        url: "client/deleteUserActivityCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DUserActivityCategories"],
    }),
    // / GoalsCategories
    getGoalCategories: build.query({
      query: () => "client/goalCategories",
      providesTags: ["GoalCategories"],
    }),
    createGoalCategories: build.mutation({
      query: (data) => ({
        url: "client/createGoalCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CGoalCategories"],
    }),
    updateGoalCategories: build.mutation({
      query: (data) => ({
        url: "client/updateGoalCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UGoalCategories"],
    }),
    deleteGoalCategories: build.mutation({
      query: (data) => ({
        url: "client/deleteGoalCategories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DGoalCategories"],
    }),
    createYogaEmpowerCategories: build.mutation({
    query: (data) =>({
      url: "client/yogaEmpowerCategories", 
      method: "POST", 
      body: data
    }),
    invalidatesTags: ['CreateYogaEmpowerCategories,']

  }),
  getYogaEmpowerCategories: build.query({
    query: () => "client/yogaEmpowerCategories",
    providesTags: ['YogaEmpowerCategories'],
    method: "GET",
  }),
  updateYogaEmpowerCategories: build.mutation({
    query: (data) => ({
      url: `client/yogaEmpowerCategories/${data.id}`,
      method: "PUT",
      body: data
    }),
    invalidatesTags: ['UpdateYogaEmpowerCategories']
  }),
  deleteYogaEmpowerCategories: build.mutation({
    query: (data) => ({
      url: `client/yogaEmpowerCategories/${data.id}`,
      method: "DELETE"
    }),
    invalidatesTags: ['DeleteYogaEmpowerCategories']    

}),
/// Coupons //
    createCoupons: build.mutation({
    query: (data) =>({
      url: "client/Coupon", 
      method: "POST", 
      body: data
    }),
    invalidatesTags: ['CreateCoupons,']

  }),
  getCoupons: build.query({
    query: () => "client/Coupon",
    providesTags: ['Coupons'],
    method: "GET",
  }),
  updateCoupons: build.mutation({
    query: (data) => ({
      url: `client/updateCoupon/${data.id}`,
      method: "PUT",
      body: data
    }),
    invalidatesTags: ['UpdateCoupons']
  }),
  deleteCoupons: build.mutation({
    query: (data) => ({
      url: `client/Coupon/${data.id}`,
      method: "DELETE"
    }),
    invalidatesTags: ['DeleteCoupons']    

})
  }),

  
});



// export api endpoints
export const {
  useGetUserQuery,
  useGetProductsQuery,
  useGetCustomersQuery,
  useGetReportedCustomersQuery,
  useGetWebsiteInterestQuery,
  useGetReportedCustomerDetailQuery,
  useUpdateDisableUserMutation = () =>{
    return useMutation()
  },
  useGetYogasQuery,
  useGetReligionsQuery,
  useCreateYogaMutation = () => {
    return useMutation()
  },
  useUpdateYogaMutation = () => {
    return useMutation()
  },
  useDeleteYogaMutation = () => {
    return useMutation()
  },

  useCreateReligionsMutation = () => {
    return useMutation()
  },

  useUpdateReligionMutation = () => {
    return useMutation()
  },
  useDeleteReligionMutation = () => {
    return useMutation()
  },
  // Contact Us Categories

  useGetContactUsCategoriesQuery,

  useCreateContactUsCategoriesMutation = () => {
    return useMutation()
  },
  useUpdateContactUsCategoriesMutation = () => {
    return useMutation()
  },

  useDeleteContactUsCategoriesMutation = () => {
    return useMutation()
  },

  /// Get Language

  useGetLanguageQuery,

  useCreateLanguageMutation = () => {
    return useMutation()
  },
  useUpdateLanguageMutation = () => {
    return useMutation()
  },

  useDeleteLanguageMutation = () => {
    return useMutation()
  },
  // CreateRequestCategories

  useGetCreateRequestCategoriesQuery,

  useCreateCreateRequestCategoriesMutation = () => {
    return useMutation()
  },
  useUpdateCreateRequestCategoriesMutation = () => {
    return useMutation()
  },

  useDeleteCreateRequestCategoriesMutation = () => {
    return useMutation()
  },
  // ServiceProviderCategories

  useGetServiceProviderCategoriesQuery,

  useCreateServiceProviderCategoriesMutation = () => {
    return useMutation()
  },
  useUpdateServiceProviderCategoriesMutation = () => {
    return useMutation()
  },

  useDeleteServiceProviderCategoriesMutation = () => {
    return useMutation()
  },
  // UserInterestCategories

  useGetUserInterestCategoriesQuery,

  useCreateUserInterestCategoriesMutation = () => {
    return useMutation()
  },
  useUpdateUserInterestCategoriesMutation = () => {
    return useMutation()
  },

  useDeleteUserInterestCategoriesMutation = () => {
    return useMutation()
  },
  // UserActivityCategories

  useGetUserActivityCategoriesQuery,

  useCreateUserActivityCategoriesMutation = () => {
    return useMutation()
  },
  useUpdateUserActivityCategoriesMutation = () => {
    return useMutation()
  },

  useDeleteUserActivityCategoriesMutation = () => {
    return useMutation()
  },
  // GoalCategories

  useGetGoalCategoriesQuery,

  useCreateGoalCategoriesMutation = () => {
    return useMutation()
  },
  useUpdateGoalCategoriesMutation = () => {
    return useMutation()
  },

  useDeleteGoalCategoriesMutation = () => {
    return useMutation()
  },

  // useDeleteYogaQuery,
  useGetTransactionsQuery,
  useGetGeographyQuery,
  useGetSalesQuery,
  useGetAdminsQuery,
  useGetUserPerformanceQuery,
  useGetDashboardQuery,
  useCreateYogaEmpowerCategoriesMutation = () => {
    return useMutation()
  },
  useGetYogaEmpowerCategoriesQuery,
  useUpdateYogaEmpowerCategoriesMutation = () => {
    return useMutation()
  },
  useDeleteYogaEmpowerCategoriesMutation = () => {
    return useMutation()
  },
  /// copons
  useCreateCouponsMutation = () => {
    return useMutation()
  },
  useGetCouponsQuery,
  useUpdateCouponsMutation = () => {
    return useMutation()
  },
  useDeleteCouponsMutation = () => {
    return useMutation()
  },

} = api;
